/**
 * La boutique est fermée tant que `NEXT_PUBLIC_SHOP_OPEN` ne vaut pas "true".
 * Fermée : pages en `noindex`, hors sitemap, aucun lien dans le menu, bouton « Commander » remplacé
 * par l'inscription à la liste d'attente. Ouverte : indexation, sitemap, menu et tunnel de vente.
 */
export const SHOP_IS_OPEN = process.env.NEXT_PUBLIC_SHOP_OPEN === "true";

/**
 * Tant que `NEXT_PUBLIC_SHOP_PUBLIC` ne vaut pas "true", la boutique n'est joignable que par le lien
 * secret (voir shop-access.ts) : aucun lien dans le menu, hors sitemap.
 */
export const SHOP_IS_PUBLIC = process.env.NEXT_PUBLIC_SHOP_PUBLIC === "true";
